module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-5_active-e212883d525264d29b760eba374db519.svg";